export const landingAssets = {
  editor: '/assets/landing/ting.png',
  projects: '/assets/landing/projects.png',
  timeline: '/assets/landing/timeline.png',
  export: '/assets/landing/export.png',
  seasons: ['/assets/landing/chun.png', '/assets/landing/xia.png', '/assets/landing/qiu.png', '/assets/landing/dong.png'],
  heroVideo: '/video/clip_core.mp4',
  ctaVideo: '/video/clip_cta.mp4',
  clips: ['/video/clip_hook.mp4', '/video/clip_point.mp4', '/video/clip_funny.mp4'],
} as const
